<template>
  <div class="about-description">
    <HTMLContent class="about-description__text" :content="descriptionText" />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import HTMLContent from '~/components/HTMLContent.vue';

export default defineComponent({
  name: 'Description',
  components: { HTMLContent },
  props: {
    descriptionText: {
      type: String,
      default: '',
    },
  },
  setup() {},
});
</script>

<style lang="scss">
.about-description {
  margin: 2.5rem 1.25rem;
  @include for-desktop {
    margin: 5rem 8.1875rem;
  }
  &__breadcrumbs {
    @include label-s;
    text-transform: uppercase;
    padding-bottom: 1.25rem;
  }
  &__text {
    @include mobile-h5;
    @include for-desktop {
      @include desktop-h5;
    }
  }
}
</style>
